import React from 'react'
import MessagesDesktop from './desktop'
import MessagesMobile from './mobile'
import useViewport from '../../../hooks/use-viewport'

const MessagesScreen = () => {
    const { breakpoint, breakpoints } = useViewport()
    const MessagesScreen = breakpoint < breakpoints.LG ? MessagesMobile : MessagesDesktop
    return (<MessagesScreen />)
}

export default MessagesScreen